export enum Race {
  noResponse = 84
}